import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ResourceReplacementRequest, ResourceReplacementResult} from "../resources/types";
import {SNIPPETS_QUERY_KEY, RESOURCE_USAGES_QUERY_KEY, TEMPLATES_QUERY_KEY} from "../queryKeys";

type Variables = {id: number} & ResourceReplacementRequest;

const replaceSnippetUsages = async ({id, ...payload}: Variables): Promise<ResourceReplacementResult> => {
  const response = await axiosReachInstance.post<ResourceReplacementResult, AxiosResponse<ResourceReplacementResult>>(
    `/snippets/${id}/replace-usages`,
    payload
  );
  return response.data;
};

export const useReplaceSnippetUsages = (
  options?: BaseMutationOptions<ResourceReplacementResult, Variables>
): BaseUseMutationResult<ResourceReplacementResult, Variables> => {
  return useBaseMutation<ResourceReplacementResult, Variables>(replaceSnippetUsages, {
    ...options,
    prefixKeysToReset: () => [[SNIPPETS_QUERY_KEY], [TEMPLATES_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY]],
  });
};
